import React, { Component, Fragment } from "react";
import axios from "../../../containers/api";
import { Row, Card, CardBody, CardTitle, Button, Collapse, FormGroup, Label, Input, Badge  } from "reactstrap";
import { Colxx} from "../../../components/common/CustomBootstrap";
import {Table} from "../../../components/table/Table";
import DatePicker, { utils } from "react-modern-calendar-datepicker";
import Config from "../../../constants/config";
import { convertDate, getDayBefore, showCatchError, toEnglishNumbers, getkalas } from "../../../helpers/Utils";
 
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
 

export default class LoadHallReserve extends Component {
    constructor(props) {
        super(props);

        this.state = {
            fromDate: getDayBefore(),
            toDate: utils("fa").getToday(),
            member: JSON.parse(localStorage.getItem("member")),
            DriverCardNumber: "",
            FreighterCardNumber: "",
            collapse: true,
            reserveId: 0,
            driverId: 0,
            reservesSearchResult: [],
            StatusSearchTypes: [
               
                {value: 0, text: 'باطل شده'},
                {value: 1, text: 'رزرو قطعی'},
                {value: 2, text: 'چاپ رزرو'},
                {value: null, text: 'همه'},

             
            ],
            selectedStatusSearchType: { value: null, text: 'همه' },
            searchTitle: "", 
            selectedSenderLists: null,
            CustomerList: [],
            selectedReceiverLists: null,
            kala: null, 
            kalas: [],
        };
    }

    componentDidMount() {
        //this.searchReserves();
        console.log('loadinfo')
        this.GetAllCustomer();
        try {
            this.getkalasApi().then(r => console.log(r));
        } catch (err) {
            console.log(err);
        }
    }
    async getkalasApi() {
        try {
            await getkalas()
                .then((res) => this.setState({ kalas: res.data }));
        } catch (err) {
            this.props.showAlert(showCatchError(err), "error");
        }
    }
    //checkPermission = () => {
    //    this.props.showSpinner();
    //    axios.get('api/ClientApi/HasAccessTo?permissionName=Reserve_List')
    //        .then((res) => {
    //            if (res.data) {
    //                this.searchReserves();

    //                if (this.state.member.memberType === 'TransportationCompanyAdmin' || this.state.member.memberType === 'TransportationCompanyMember') {
    //                    this.GetAllCustomer();
                     
    //                }  
    //            } else {
    //                this.props.history.push('/error404');
    //            }
    //        })
    //        .catch((error) => {
    //            this.props.hideSpinner();
    //            this.props.showAlert(showCatchError(error), "error");
    //        });
    //};

    searchReserves = () => {
        this.props.showSpinner();

        
        let model = {
            FromDate: convertDate(this.state.fromDate),
            ToDate: convertDate(this.state.toDate),
            DriverCardNumber: this.state.DriverCardNumber,
            FreighterCardNumber: this.state.FreighterCardNumber,
            DriverReserveStatus: this.state.selectedStatusSearchType.value!==null? toEnglishNumbers(this.state.selectedStatusSearchType.value):null,
            ReceiverCustomerId: this.state.selectedReceiverLists !== null ? this.state.selectedReceiverLists.id : null,
            SenderCustomerId: this.state.selectedSenderLists !== null ? this.state.selectedSenderLists.id : null, 
            KalaId: this.state.kala!==null? this.state.kala.id:null,
        }

        axios.post('/api/v1/driver-reservations/SearchDriverReserve', model)
            .then((res) => {
                this.props.hideSpinner();
                if (res.data.data.length > 0) {
                   
                    this.setState({
                        reservesSearchResult: res.data.data,
                        collapse: false,
                       
                    });
                } else {
                    this.setState({reservesSearchResult: []});
                    this.props.showAlert('رزروی یافت نشد.', "warning");
                }
            })
            .catch((error) => {
                console.log(error)
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
            });
    };

   
    GetAllCustomer = () => {
            axios.get('/api/v1/customers/GetAllCustomer')
                .then((res) => {
                    this.props.hideSpinner();
                    this.setState({ CustomerList: res.data.data });
                })
                .catch((error) => {
                    this.props.hideSpinner();
                    console.log(error.response);
                    this.props.showAlert(showCatchError(error), "error");
                });
        };
   
    
    resetSearch = () => {
        this.setState({
            fromDate: getDayBefore(),
            toDate: utils("fa").getToday(),
            DriverCardNumber: "",
            FreighterCardNumber: "",
            selectedStatusSearchType: { value: null, text: 'همه' },
            selectedReceiverLists: null, 
            selectedSenderLists: null,
            kala: null, 
            
        });
    }
    async getkalasApi() {
        try {
            await getkalas()
                .then((res) => this.setState({ kalas: res.data }));
        } catch (err) {
            this.props.showAlert(showCatchError(err), "error");
        }
    }

     
    CancelReserve = (Id) => {
        this.props.showSpinner();
        //let model = {
        //    Id:Id,
        //    CancelType: true, 
        //}

            // axios.post('/api/v1/driver-reservations/cancel', model) 
        axios.patch(`/api/v1/driver-reservations/cancel/${Id}`)
            .then((res) => {
                this.props.hideSpinner();
                this.props.closeSweetAlert();
                this.searchReserves();
                this.props.showAlert(res.data.message, "success");
            })
            .catch((error) => {
                this.props.closeSweetAlert();
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
            });
    };
  
    printReserve = (reserveId, format) => {
        let postData = {
            responseType: "arraybuffer"
        }

        this.props.showSpinner();
        axios.get('api/ReportApi/Search_DriverLoadReserve?driverLoadReserveId=' + reserveId + '&ExportFormat=' + format, postData)
            .then((res) => {
                this.props.hideSpinner();
                if (format === 'pdf') {
                    let blob = new Blob([res.data], {type: "application/pdf"});
                    let objectUrl = URL.createObjectURL(blob);
                    window.open(objectUrl);
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                let decoder = new TextDecoder("utf-8");
                if (error.response != null) {
                    let domString = decoder.decode(error.response.data);
                    if (domString !== null && domString.trim() !== "" && domString.trim() !== undefined) {
                        let msg = domString.replace("-", " ");
                        let msg1 = msg.replace('"', ' ');
                        let msg2 = msg1.replace('"', ' ');
                        this.props.showAlert(msg2, "error");
                    } else {
                        this.props.showAlert("در چاپ خطايی رخ داده است", "error");
                    }
                } else {
                    this.props.showAlert("در چاپ خطايی رخ داده است", "error");
                }
            });
    };

    
    

    closeModal = (modalName) => {
        this.setState({ [modalName]: false });

       
    };

    selectHandleChange = (event, value, name) => {
        this.setState({[name]: value });
    };

    render() {
        const {collapse, toDate, fromDate, DriverCardNumber, FreighterCardNumber, reservesSearchResult} = this.state;

        return (
            <Fragment>
                <Row>
                    <Colxx xxs="12" className="mb-4">
                        <Card>
                            <CardBody>
                            <CardTitle>جستجو</CardTitle> 
                                    <div className="p-4 pt-5 border d-flex flex-column">
                                        <div className="d-flex flex-md-row flex-column justify-content-between">
                                            <FormGroup className="w-md-25 w-100 px-1">
                                                <Label>از تاریخ</Label>
                                                <DatePicker
                                                    value={fromDate}
                                                    onChange={(newDate) => {this.setState({fromDate: newDate});}}
                                                    inputPlaceholder="لطفا یک تاریخ انتخاب کنید"
                                                    shouldHighlightWeekends
                                                    inputClassName="form-control"
                                                    locale="fa"
                                                    calendarClassName="calendar"
                                                    colorPrimary={Config.color}
                                                    calendarPopperPosition={'bottom'}
                                                />
                                            </FormGroup>

                                            <FormGroup className="w-md-25 w-100 px-1">
                                                <Label>تا تاریخ</Label>
                                                <DatePicker
                                                    value={toDate}
                                                    onChange={(newDate) => {this.setState({toDate: newDate});}}
                                                    inputPlaceholder="لطفا یک تاریخ انتخاب کنید"
                                                    shouldHighlightWeekends
                                                    inputClassName="form-control"
                                                    locale="fa"
                                                    calendarClassName="calendar"
                                                    colorPrimary={Config.color}
                                                    calendarPopperPosition={'bottom'}
                                                />
                                            </FormGroup>

                                            <FormGroup className="w-md-25 w-100 px-1">
                                                <Label>شماره هوشمند راننده</Label>
                                                <Input value={DriverCardNumber} onChange={(e) => this.setState({DriverCardNumber: e.target.value})}/>
                                            </FormGroup>

                                            <FormGroup className="w-md-25 w-100 px-1">
                                                <Label>شماره هوشمند ناوگان</Label>
                                                <Input value={FreighterCardNumber} onChange={(e) => this.setState({FreighterCardNumber: e.target.value})}/>
                                            </FormGroup>
                                        </div>
                                            <div className="d-flex flex-md-row flex-column justify-content-between">

                                            
                                            <FormGroup className="w-md-25 w-100 px-1">
                                                <Label>وضعیت</Label>
                                                <Autocomplete
                                                    disableClearable
                                                    clearText={"حذف"}
                                                    closeText={"بستن"}
                                                    noOptionsText={"در حال دریافت اطلاعات.."}
                                                    openText={"باز کردن"}
                                                    className="react-select__control"
                                                    id="selectedStatusSearchType"
                                                    options={this.state.StatusSearchTypes}
                                                    getOptionLabel={(option) => option.text}
                                                    value={this.state.selectedStatusSearchType}
                                                    onChange={(e, v) => this.selectHandleChange(e, v, "selectedStatusSearchType")}
                                                    renderInput={(params) => (<TextField{...params} variant="standard" />)}
                                                />
                                            </FormGroup>
                                            
                                                    <FormGroup className="w-md-25 w-100 px-1">
                                                        <Label>فرستنده</Label>
                                                        <Autocomplete
                                                            noOptionsText={"در حال دریافت اطلاعات.."}
                                                            openText={"باز کردن"}
                                                            className="react-select__control"
                                                            id="selectedSenderLists"
                                                            options={this.state.CustomerList}
                                                    getOptionLabel={(option) => option.customerFullName + ' (' + option.meliCode + ')'}
                                                            value={this.state.selectedSenderLists}
                                                            onChange={(e, v) => this.selectHandleChange(e, v, "selectedSenderLists")}
                                                            renderInput={(params) => (<TextField{...params} variant="standard"/>)}
                                                        />
                                                    </FormGroup>

                                                    <FormGroup className="w-md-25 w-100 px-1">
                                                        <Label>گیرنده</Label>
                                                        <Autocomplete
                                                            noOptionsText={"در حال دریافت اطلاعات.."}
                                                            openText={"باز کردن"}
                                                            className="react-select__control"
                                                            id="selectedReceiverLists"
                                                            options={this.state.CustomerList}
                                                    getOptionLabel={(option) => option.customerFullName + ' (' + option.meliCode + ')'}
                                                            value={this.state.selectedReceiverLists}
                                                            onChange={(e, v) => this.selectHandleChange(e, v, "selectedReceiverLists")}
                                                            renderInput={(params) => (<TextField{...params} variant="standard"/>)}
                                                        />
                                                    </FormGroup>
                                                
                                            

                                            <FormGroup className="w-md-25 w-100 px-1">
                                                <Label>*نوع محموله:</Label>
                                                <Autocomplete
                                                    clearText={"حذف"}
                                                    closeText={"بستن"}
                                                    noOptionsText={"در حال دریافت اطلاعات.."}
                                                    openText={"باز کردن"}
                                                    className="react-select__control"
                                                    id="kala"
                                                    options={this.state.kalas}
                                                    getOptionLabel={(option) => option.kalaDesc}
                                                    value={this.state.kala}
                                                    onChange={(e, v) => this.selectHandleChange(e, v, "kala")}
                                                    renderInput={(params) => (<TextField{...params} variant="standard" />)}
                                                />
                                            </FormGroup>
                                        </div>

                                        <div className="d-flex mt-2 justify-content-center">
                                            <FormGroup className="text-center">
                                                <Button color="primary" className="btn-lg mx-2" onClick={this.searchReserves}>
                                                    جستجو
                                                </Button>
                                            </FormGroup>
                                            <FormGroup className="text-center">
                                                <Button color="primary" className="btn-lg mx-2" onClick={this.resetSearch}>
                                                    پاک کردن
                                                </Button>
                                            </FormGroup>
                                        </div>
                                    </div>

                                {this.state.searchTitle !== "" ?
                                    <CardTitle className="d-flex w-100 justify-content-md-start justify-content-center mt-5"> نتایج جستجو ({this.state.searchTitle})</CardTitle>
                                    :
                                    null
                                }

                                {reservesSearchResult ?
                                    <Table
                                        tableHeaders={[
                                            "شناسه",
                                            "شناسه بار",
                                            "وضعیت",
                                            "شركت حمل و نقل",
                                            "فرستنده",
                                            "گیرنده", 
                                            "نام راننده",
                                            "موبایل",
                                            "هوشمند راننده",
                                            "هوشمند ماشين",
                                            "پلاک", 
                                            "محموله", 
                                         
                                            //"چاپ",
                                           
                                        ]}

                                        tableRow={this.state.reservesSearchResult}

                                        tableData={[
                                            reserve => {
                                                return reserve.id;
                                            },
                                            reserve => {
                                                return reserve.cargoId;
                                            },
                                            reserve => {
                                                switch (reserve.status) {
                                                    case 0:
                                                        return <Badge color="outline-danger" pill>باطل شده</Badge>;
                                                    case 1:
                                                        return <Badge color="outline-warning" pill>رزرو بار</Badge>;
                                                    case 2:
                                                        return <Badge color="outline-warning" pill>چاپ</Badge>;
                                                }
                                            },
                                            reserve => {
                                                return reserve.transportationCompanyName !== null && reserve.transportationCompanyName;
                                            },
                                            reserve => {
                                                return reserve.senderCustomerName;
                                            },
                                            reserve => {
                                                return reserve.receiverCustomerName;
                                            },
                                            
                                            reserve => {
                                                return reserve.driverName + " " + reserve.driverFamily;
                                            },
                                            reserve => {
                                                return reserve.driverMobile;
                                            },
                                            reserve => {
                                                return reserve.driverCardNumber;
                                            },
                                            reserve => {
                                                return reserve.freighterCardNumber;
                                            },
                                            reserve => {
                                                return reserve.plaque  
                                            },
                                             
                                            reserve => {
                                                return reserve.kalaDesc;
                                            },
                                             
                                          
                                             
                                            //reserve => {
                                            //    if (reserve.status !== 0 && (reserve.status === 1 || reserve.status === 7 || reserve.status === 9) ) {
                                            //        return (
                                            //            <Button outline color="primary" size="sm"
                                            //                    onClick={() => this.printReserve(reserve.driverLoadReserveID, 'pdf')}>
                                            //                چاپ
                                            //            </Button>
                                            //        )
                                            //    }
                                            //}, 
                                           
                                        ]}
                                    />
                                    :
                                    null
                                }
                            </CardBody>
                        </Card>
                    </Colxx>
                </Row>


                 

                 

                 

                 
            </Fragment>
        )
    }
}
